export default __webpack_public_path__ + "static/media/register-v2.4620a1e5.svg";